import { forwardRef, useCallback } from 'react';
import { PanelPortal, type PanelPortalProps } from './panel-portal';
import { usePanelStore } from './store';

type GlobalPanelEntryProps = Omit<PanelPortalProps, 'onClose'> & {
  onClose?: () => void;
};

export const GlobalPanelEntry = forwardRef<HTMLDivElement, GlobalPanelEntryProps>(
  ({ children, id, onClose, enableAnimations = true, ...rest }: GlobalPanelEntryProps, ref) => {
    const setOpenGlobalPanel = usePanelStore((s) => s.setOpenGlobalPanel);
    // We subscribe only to the global panel state of the assigned id to avoid unnecessary re-renders
    // when other global panels are opened/closed
    const isOpenGlobalPanel = usePanelStore((s) => s.openGlobalPanels?.[id]);

    const handleClose = useCallback(() => {
      setOpenGlobalPanel(id, false);
      onClose?.();
    }, [id, setOpenGlobalPanel, onClose]);

    if (!isOpenGlobalPanel) {
      return null;
    }

    return (
      <PanelPortal enableAnimations={enableAnimations} id={id} onClose={handleClose} {...rest} ref={ref}>
        {children}
      </PanelPortal>
    );
  }
);
